import { supabase } from './api'

export const revalidate = 0

function getCompanyId() {
	return localStorage.getItem('companyId')
}

export async function getAllData() {
	const companyId = getCompanyId()
	const { data, error } = await supabase.from('classview').select().eq('companyId', companyId)

	if (error) {
		throw new Error('Failed to fetch data')
	}

	return data
}

export async function getInstructorIdData(instructorId) {
	const companyId = getCompanyId()
	const { data, error } = await supabase
		.from('classview')
		.select()
		.eq('companyId', companyId)
		.or(`instructorId.eq.${instructorId},subinstructorId.eq.${instructorId}`)
		.order('class_name', { ascending: true })

	if (error) {
		throw new Error('Failed to fetch data', error)
	}
	return data
}

export async function getInstructorIdDataforInstrucor(instructorId) {
	const companyId = getCompanyId()
	const { data, error } = await supabase
		.from('classview')
		.select()
		.eq('companyId', companyId)
		.or(`instructorId.eq.${instructorId},subinstructorId.eq.${instructorId}`)
		.eq('isActive', true)
		.order('class_name', { ascending: true })

	if (error) {
		throw new Error('Failed to fetch data', error)
	}

	return data
}

export async function getIdData(id) {
	const { data, error } = await supabase.from('classview').select().eq('id', id)
	if (error) {
		throw new Error('Failed to fetch data')
	}

	return data
}

export async function getStudentIdData(id) {
	const companyId = getCompanyId()
	const prm = `studentId.eq.${id},studentId.is.null`
	const { data, error } = await supabase.from('classview').select().eq('companyId', companyId).or(prm).order('class_name', { ascending: true })
	if (error) {
		throw new Error('Failed to fetch data')
	}

	return data
}

export async function addData(adata) {
	const { data, error } = await supabase.from('classview').insert(adata).select()

	if (error) {
		throw new Error('Failed to fetch data')
	}

	return data
}

export async function updateData(udata) {
	console.log('udata', udata)
	const { data, error } = await supabase.from('classview').update(udata).eq('id', udata.id).select()

	if (error) {
		throw new Error('Failed to fetch data')
	}

	return data
}

export async function deleteIdData(id) {
	const { data, error } = await supabase.from('classview').delete().eq('id', id)
	if (error) {
		throw new Error('Failed to fetch data')
	}

	return data
}
